/**
 * Converts strings like "some_string" to "someString"
 * @param string
 * @returns string
 */
export const snakeToCamel = string =>
    string.replace(/([-_][a-z])/ig, ($1) =>
        $1.toUpperCase().replace("_", ""));